/* eslint-disable react/no-array-index-key */
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  Box,
  CircularProgress,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';
import { updateSubUserNickName } from '../../modules/picareDashboard';

const COLUMNS = [
  { id: 'serial', label: '시리얼' },
  { id: 'userId', label: '계정' },
  { id: 'nickName', label: '사용자명' },
  { id: 'agency', label: '보급처' },
];

const toRows = (hw) => {
  const base = { serial: hw.serial || '-', agency: hw.agency || '-' };
  if (!hw.subUsers?.length)
    return [{ ...base, userId: null, name: '-', nickName: '-' }];
  return hw.subUsers.map((u) => ({
    ...base,
    userId: u.userId || null,
    name: u.name || '-',
    nickName: u.nickName || '-',
  }));
};

const NickNameCell = ({ row }) => {
  const dispatch = useDispatch();
  const [value, setValue] = useState(row.nickName);
  const [focused, setFocused] = useState(false);

  const handleBlur = () => {
    setFocused(false);
    if (!row.userId || value === row.nickName) return;
    dispatch(updateSubUserNickName({ userId: row.userId, nickName: value }));
  };

  if (!row.userId) {
    return (
      <TableCell sx={{ fontSize: '0.75rem', padding: '4px 8px' }}>
        {row.nickName}
      </TableCell>
    );
  }

  return (
    <TableCell sx={{ padding: '2px 4px' }}>
      <input
        value={value}
        onChange={(e) => setValue(e.target.value)}
        onFocus={() => setFocused(true)}
        maxLength={20}
        onBlur={handleBlur}
        style={{
          width: '100%',
          fontSize: '0.75rem',
          border: focused ? '1px solid #94a3b8' : '1px solid transparent',
          borderRadius: 4,
          padding: '2px 4px',
          background: '#f6f7f9',
          outline: 'none',
          boxSizing: 'border-box',
          fontWeight: 'bold',
          fontFamily: 'Noto Sans KR',
          color: '#475569',
        }}
      />
    </TableCell>
  );
};

const PiCareSupplyTable = () => {
  const { hwList, loading } = useSelector((state) => state.picareDashboard);
  const rows = hwList.flatMap(toRows);

  if (loading.hwList) {
    return (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100%',
        }}
      >
        <CircularProgress color="secondary" />
      </Box>
    );
  }

  return (
    <TableContainer
      component={Paper}
      elevation={0}
      sx={{ border: '1px solid #e2e8f0', height: '100%', overflow: 'auto' }}
    >
      <Table size="small" stickyHeader>
        <TableHead>
          <TableRow sx={{ background: '#f8fafc' }}>
            {COLUMNS.map((col) => (
              <TableCell
                key={col.id}
                sx={{
                  fontSize: '0.75rem',
                  fontWeight: 'bold',
                  color: '#475569',
                  padding: '4px 8px',
                }}
              >
                {col.label}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.length === 0 ? (
            <TableRow>
              <TableCell
                colSpan={COLUMNS.length}
                align="center"
                sx={{ color: '#94a3b8', py: 3, fontSize: '0.75rem' }}
              >
                데이터가 없습니다
              </TableCell>
            </TableRow>
          ) : (
            rows.map((row, i) => (
              <TableRow
                key={`${row.serial}-${i}`}
                hover
                sx={{ '&:last-child td': { border: 0 } }}
              >
                <TableCell
                  sx={{
                    fontSize: '0.75rem',
                    padding: '4px 8px',
                    fontFamily: 'Noto Sans KR',
                  }}
                >
                  {row.serial.substring(0, 10).toUpperCase()}
                </TableCell>
                <TableCell
                  sx={{
                    fontSize: '0.75rem',
                    padding: '4px 8px',
                    fontFamily: 'Noto Sans KR',
                  }}
                >
                  {row.userId || '-'}
                </TableCell>
                <NickNameCell row={row} />
                <TableCell sx={{ fontSize: '0.75rem', padding: '4px 8px' }}>
                  {row.agency}
                </TableCell>
              </TableRow>
            ))
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default PiCareSupplyTable;
